import styled from 'styled-components'

export const ScrollableContainer = styled.div`
    height: 80vh;
`

export const ScrollableCol = styled.div`
    height: 100%;
    overflow-y: scroll;
`